<template>
    <ModalBase v-show="visible" modal-type="success" @close="visible = !visible">
        <template #header>
            {{ $t('dialog.auth.forgotPassword.title') }}
        </template>
        <template #body>
            <p class="font-bold text-center">
                {{ $t('dialog.auth.forgotPassword.subtitle') }}
            </p>

            <input v-model="tempSmsPw.value"
                   class="border border-gray-500 rounded py-2 pl-2 mt-3"
                   :class="{ 'border-red-600' : tempSmsPw.error }"
                   :placeholder="$t('dialog.auth.forgotPassword.tempSmsPw.placeholder')">
            <label class="text-red-600"
                   v-if="tempSmsPw.error !== ''">
                {{ tempSmsPw.error }}
            </label>

            <input v-model="password.value"
                   type="password"
                   class="border border-gray-500 rounded py-2 pl-2 mt-3"
                   :class="{ 'border-red-600' : password.error }"
                   :placeholder="$t('dialog.auth.forgotPassword.password.placeholder')">
            <label class="text-red-600"
                   v-if="password.error !== ''">
                {{ password.error }}
            </label>

            <input v-model="password_confirm.value"
                   type="password"
                   @keyup.enter="reset"
                   class="border border-gray-500 rounded py-2 pl-2 mt-3"
                   :class="{ 'border-red-600' : password_confirm.error }"
                   :placeholder="$t('dialog.auth.forgotPassword.password_confirm.placeholder')">
            <label class="text-red-600"
                   v-if="password_confirm.error !== ''">
                {{ password_confirm.error }}
            </label>
        </template>
        <template #footer-without-padding>
            <div class="w-full flex justify-between px-4 pb-4">
                <div>
                </div>
                <div>
                    <button @click="reset"
                            class="bg-blue-500 font-bold text-white px-4 py-1 w-24">
                        {{ $t('dialog.auth.forgotPassword.reset') }}
                    </button>
                </div>
            </div>
        </template>
    </ModalBase>
</template>

<script>
    import ModalBase from "@/components/shared/ModalBase";
    import {UserService, ValidationError} from "@/services/user.service";

    export default {
        name: "ForgotPasswordModal",
        data() {
          return {
              visible: true,
              tempSmsPw: {
                  value: '',
                  error: ''
              },
              password: {
                  value: '',
                  error: ''
              },
              password_confirm: {
                  value: '',
                  error: ''
              }
          }
        },
        components: { ModalBase },
        methods: {
            reset() {
                try {
                    UserService.resetPassword(this.password.value, this.password_confirm.value);
                } catch (e) {
                    if (e instanceof ValidationError) {
                        if (e.fields.length > 0) {
                            e.fields.forEach(function (field) {
                                if (field.field === 'new_password') {
                                    this.password.error = field.error_text;
                                } else if (field.field === 'new_password_confirm') {
                                    this.password_confirm.error = field.error_text;
                                }
                            });
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>